import { BASE_URL } from '@src/utils/constants';
import axios from 'axios';

export const GetAllUser = async (token, page, limit, filter = '') => {
    try {
        const response = await axios.get(`${BASE_URL}/users?page=${page}&limit=${limit}&filter=${filter}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};

export const GetUser = async (token) => {
    try {
        const response = await axios.get(`${BASE_URL}/user/users`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};

export const updateUserDetails = async (dataSent) => {
    const token = localStorage.getItem("token");
    if ( !token ) return;
    try {
        const response = await axios.post(
            `${BASE_URL}/user/update_details`,
            JSON.stringify(dataSent),
            {
              timeout: 12000,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              validateStatus: (status) => status >= 200 && status <= 505,
            }
          );

          if ( response.status != 200 ){
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data?.data || null, // You can optionally return the response data if needed
            };
          }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            console.log(error);
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};



export const changePassword = async (dataSent) => {
    const token = localStorage.getItem("token");
    if ( !token ) return;
    try {
        const response = await axios.post(
            `${BASE_URL}/user/password/update`,
            JSON.stringify(dataSent),
            {
              timeout: 12000,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              validateStatus: (status) => status >= 200 && status <= 505,
            }
          );

          if ( response.status != 200 ){
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data?.data || null, // You can optionally return the response data if needed
            };
          }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            console.log(error);
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};

export const GetAllAffiliate = async (token, page, limit) => {
    try {
        const response = await axios.get(`${BASE_URL}/users/affiliate?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};


export const GetAllCorporate = async (token, page, limit) => {
    try {
        const response = await axios.get(`${BASE_URL}/users/type/corporate?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};

export const GetAllSchool = async (token, page, limit) => {
    try {
        const response = await axios.get(`${BASE_URL}/users/type/school?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};


export const GetAllTransactions = async (token, page, limit) => {
    try {
        const response = await axios.get(`${BASE_URL}/transactions?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};

export const GetDashboardData = async (token) => {
    try {
        const response = await axios.get(`${BASE_URL}/general_stats`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};

export const GetYearlyData = async (token,year) => {
    try {
        const response = await axios.get(`${BASE_URL}/yearly_transactions?year=${year}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(response);

        if (response.status != 200) {
            return {
                statusCode: response.data?.statusCode,
                message: response.data?.message,
                data: response.data.users || null,
            };
        }

        const { data } = response;
        return data;
    } catch (error) {
        // Check if error is an AxiosError
        if (axios.isAxiosError(error)) {
            const statusCode = error.response?.status || 0;
            const message = error.message || 'Unknown error occurred';
            
            return {
                statusCode: statusCode,
                message: message,
                data: error.response?.data || null, // You can optionally return the response data if needed
            };
        } else {
            return { statusCode: 0, message: 'An unexpected error occurred' };
        }
    }
};